<template>
  <b-overlay
    :show="busy"
    spinner-type="grow"
    spinner-variant="primary"
    rounded="sm"
  >
    <b-card class="border-none py-0 mb-0 no-margin px-1 componentview">
      <b-card-body class="py-0">
        <div>
          <b-row>
            <b-col cols="12" md="5">
              <b-form-group label="From" label-for="from" label-cols="12">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="emailfrom"
                    disabled
                    placeholder="From"
                    size="sm"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="emailfrom = ''"
                      disabled
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="5">
              <b-form-group label="Email To" label-for="email" label-cols="12">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="email"
                    placeholder="Email"
                    size="sm"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="email = ''"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" md="10">
              <b-form-group label="Subject" label-for="subject" label-cols="12">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="subject"
                    disabled
                    placeholder="Subject"
                    size="sm"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="subject = ''"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="10">
              <b-form-group label="Message" label-for="message" label-cols="12">
                <wysiwyg v-model="body" placeholder="Message..." />
                <!-- <b-input-group>
                  <b-form-textarea
                    id="message"
                    v-model="body"
                    placeholder="Message..."
                    disabled="true"
                    rows="3"
                    max-rows="6"
                  ></b-form-textarea>
                </b-input-group> -->
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="5">
              <b-form-checkbox
                id="copy"
                v-model="copy"
                name="copy"
                value="true"
                unchecked-value="false"
              >
                Send me a copy (
                <span class="text-primary">{{ user.email }}</span> )
              </b-form-checkbox>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="10" class="text-right">
              <b-button-group>
                <b-button squared size="sm" @click="send()" variant="primary">
                  <i class="fa fa-paper-plane pr-3"></i>Send
                </b-button>
              </b-button-group>
            </b-col>
          </b-row>
          <!--    <b-row>
            <b-col cols="12" sm="4">
              <b-form-group label="Email To" label-for="email" label-cols="12">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="email"
                    placeholder="Email"
                    size="sm"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="email = ''"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                  <b-button squared size="sm" @click="send()" variant="primary">
                    <i class="fa fa-paper-plane pr-3"></i>Send
                  </b-button>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row> -->
        </div>
      </b-card-body>
      <b-card-footer class="mt-2 ml-1">
        <b-row>
          <b-col class="text-left">
            <div v-if="busy">
              <i class="fa fa-spinner fa-spin text-primary"></i>
            </div>
            <div v-else>
              <span v-html="message"></span>
            </div>
          </b-col>
          <b-col class="text-right" cols="8">
            <b-button
              squared
              size="sm"
              variant="secondary"
              class="mr-1"
              @click="discard"
            >
              <i class="fa fa-chevron-left pr-1"></i>
              Back
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </b-overlay>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "EmailStatement",
  async mounted() {
    this.email = this.user.email;
    this.emailfrom = await this.getsystemsetting("email_statement_from");
    this.body = await this.getsystemsetting("email_statement");
    if (this.selection.length > 1) {
      this.subject = "Statement from Travel Places Ltd for <each client>";
    } else {
      this.subject =
        "Statement from Travel Places Ltd for " + this.selection[0].to;
    }
  },
  data() {
    return {
      busy: false,
      message: "",
      email: null,
      emailfrom: null,
      subject: null,
      message: null,
      body: null,
      copy: true,
    };
  },
  methods: {
    async send() {
      this.busy = true;

      let rows = [];
      for (var j = 0; j < this.selection.length; ++j) {
        rows.push({
          id: this.selection[j].id,
          datestatement: this.selection[j].datestatement,
          slac: this.selection[j].slac,
        });
      }
      let variables = {
        selected: rows,
        documentformat: "STM_1",
        emailto: this.email,
      };

      console.log("variables", variables);

      let sent = false;
      try {
        const response = await this.$apollo.query({
          query: gql`
            query statements(
              $selected: [Statement_input]
              $documentformat: String
              $emailto: String
            ) {
              statements(
                selected: $selected
                documentformat: $documentformat
                emailto: $emailto
              ) {
                slac
                to
                outstanding
                datelast
              }
            }
          `,
          variables,
        });

        this.items = response.data.statements;
        sent = response.data.statements.length > 0 ? true : false;
      } catch (error) {
        console.log(error);
      }

      if (sent) {
        this.message = "<span class='text-primary'>Emailed it.</span>";
      } else {
        this.message = "<span class='text-danger'>Email not sent!</span>";
      }
      this.busy = false;
    },
  },
};
</script>

<style>
</style>